import React, { useState } from 'react';
import Button from './Button';

const legalFields = [
  { label: 'Bankruptcy', description: 'Dealing with debt and financial distress' },
  { label: 'Business', description: 'Starting, managing, or selling a business' },
  { label: 'Criminal', description: 'Facing criminal charges or legal defense' },
  { label: 'Employment', description: 'Workplace disputes and employee rights' },
  { label: 'Family', description: 'Divorce, custody, and family matters' },
  { label: 'Immigration', description: 'Navigating immigration laws and processes' },
  { label: 'Intellectual Property', description: 'Protecting inventions, trademarks, and copyrights' },
  { label: 'Personal Injury', description: 'Injuries caused by negligence or accidents' },
  { label: 'Real Estate', description: 'Property transactions and disputes' },
  { label: 'Tax', description: 'Tax planning, compliance, and disputes' },
  { label: "Other / I'm not sure", description: "Legal issues not covered by other categories or if you're uncertain" },
];

const ManualSelectForm = ({ onSelect, onSkip }) => {
  const [selected, setSelected] = useState(legalFields[0].label);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900">What type of legal issue are you facing?</h2>
          <p className="mt-4 text-lg text-gray-500">
            Select the area of law that best describes your situation. This will help us connect you with the right professionals.
          </p>
        </div>
        <form onSubmit={e => { e.preventDefault(); onSelect(selected); }}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {legalFields.map(field => (
              <label key={field.label} className={`flex items-center gap-4 rounded-lg border p-5 cursor-pointer transition-all ${selected === field.label ? 'border-blue-600 bg-blue-50 ring-2 ring-blue-200' : 'border-gray-300 hover:border-blue-600 hover:bg-blue-50'}`}>
                <input
                  type="radio"
                  name="legal_field"
                  value={field.label}
                  checked={selected === field.label}
                  onChange={() => setSelected(field.label)}
                  className="h-5 w-5 border-2 appearance-none rounded-full focus:outline-none focus:ring-0 focus:ring-offset-0"
                />
                <div>
                  <p className="font-semibold text-gray-900">{field.label}</p>
                  <p className="text-sm text-gray-500">{field.description}</p>
                </div>
              </label>
            ))}
          </div>
          <div className="mt-12 flex flex-col gap-4 items-center">
            <Button
              type="submit"
              className="w-full bg-blue-600 text-white font-bold py-3 rounded-md shadow-sm hover:bg-blue-700"
            >
              Select
            </Button>
            <Button
              type="button"
              className="w-full bg-gray-100 text-gray-800 font-bold py-3 rounded-md border border-gray-300 hover:bg-gray-200"
              onClick={onSkip}
            >
              <span className="material-symbols-outlined align-middle mr-2">arrow_back</span>
              Back
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManualSelectForm;
